{
	"name": "@lucidcms/core",
	"version": "0.11.0-alpha.0",
	"description": "The core of the Lucid CMS. It's responsible for spinning up the API and serving the CMS.",
	"type": "module",
	"types": "./dist/index.d.ts",
	"module": "dist/index.js",
	"exports": {
		".": {
			"import": "./dist/index.js",
			"types": "./dist/index.d.ts"
		},
		"./api": {
			"types": "./dist/api.d.ts",
			"default": "./dist/api.js"
		},
		"./builders": {
			"types": "./dist/builders.d.ts",
			"default": "./dist/builders.js"
		},
		"./middleware": {
			"types": "./dist/middleware.d.ts",
			"default": "./dist/middleware.js"
		},
		"./helpers": {
			"types": "./dist/helpers.d.ts",
			"default": "./dist/helpers.js"
		},
		"./types": {
			"types": "./dist/types.d.ts",
			"default": "./dist/types.js"
		},
		"./package.json": "./package.json"
	},
	"scripts": {
		"build": "tsc && tsup",
		"dev": "tsup --watch",
		"format": "biome format ./src",
		"format:fix": "biome format --write ./src",
		"lint": "biome lint ./src",
		"lint:fix": "biome lint --apply ./src"
	},
	"files": ["dist", "cms", "templates", "assets"],
	"author": "Proto Digital",
	"repository": {
		"type": "git",
		"url": "git+https://github.com/ProtoDigitalUK/lucid_cms.git",
		"directory": "packages/core"
	},
	"keywords": [
		"CMS",
		"Headless",
		"Node.js",
		"Typescript",
		"ESM",
		"Fastify",
		"Kysely"
	],
	"devDependencies": {
		"@biomejs/biome": "^1.9.4",
		"@lucidcms/admin": "*",
		"@lucidcms/config": "*",
		"@types/jsonwebtoken": "^9.0.9",
		"@types/lodash.merge": "^4.6.9",
		"@types/mime-types": "^2.1.4",
		"@types/mjml": "^4.7.4",
		"@types/node": "^22.15.2",
		"@types/node-cron": "^3.0.11",
		"@types/sanitize-html": "^2.15.0",
		"@types/semver": "^7.7.0",
		"@types/slug": "^5.0.9",
		"tsup": "^8.4.0",
		"typescript": "^5.8.3"
	},
	"dependencies": {
		"@fastify/cookie": "^11.0.2",
		"@fastify/cors": "^11.0.1",
		"@fastify/helmet": "^13.0.1",
		"@fastify/rate-limit": "^10.2.2",
		"@fastify/static": "^8.1.1",
		"@fastify/swagger": "^9.5.0",
		"@lucidcms/admin": "0.11.0-alpha.0",
		"@scalar/fastify-api-reference": "^1.28.26",
		"@tailwindcss/vite": "^4.1.4",
		"argon2": "^0.43.0",
		"blurhash": "^2.0.5",
		"date-fns": "^4.1.0",
		"fast-average-color-node": "^3.1.0",
		"fastify": "^5.3.2",
		"fastify-plugin": "^5.0.1",
		"handlebars": "^4.7.8",
		"jiti": "^2.4.2",
		"jsonwebtoken": "^9.0.2",
		"kysely": "0.27.4",
		"lodash.merge": "^4.6.2",
		"mime-types": "^3.0.1",
		"mjml": "^5.0.0-alpha.6",
		"node-cron": "^3.0.3",
		"sanitize-html": "^2.16.0",
		"semver": "^7.7.1",
		"sharp": "^0.33.5",
		"slug": "^10.0.0",
		"solid-js": "^1.9.5",
		"tailwindcss": "^4.1.4",
		"vite": "^6.3.5",
		"vite-plugin-solid": "^2.11.6",
		"winston": "^3.17.0",
		"zod": "^4.0.0-beta"
	},
	"volta": {
		"node": "22.15.0"
	},
	"engines": {
		"node": ">=22.0.0 <23.0.0"
	},
	"license": "BSL-1.0"
}
